/** @jsxImportSource @emotion/react */
import { colors } from '../../../ui';

const Burger = ({ open, onClick }) => (
  <div
    onClick={onClick}
    css={{
      width: 52,
      height: 52,
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: colors.black,
      borderRadius: 4,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      '>div': {
        width: 20,
        height: 2,
        borderRadius: 1,
        background: colors.black,
        transition: '.2s',
      },
      '>div:not(:last-of-type)': { marginBottom: 6 },
      cursor: 'pointer',
      svg: { color: colors.black, transition: '.2s' },
      transition: '.2s',
      ':hover': {
        borderColor: colors.blue,
        div: { background: colors.blue },
        svg: { color: colors.blue },
      },
    }}
  >
    {open ? (
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.4695 10.9772L19.7595 2.68724C19.9234 2.49593 20.009 2.24986 19.9993 1.99818C19.9895 1.74651 19.8852 1.50777 19.7071 1.32967C19.529 1.15158 19.2903 1.04725 19.0386 1.03752C18.7869 1.0278 18.5408 1.11341 18.3495 1.27724L10.0595 9.56724L1.76954 1.26724C1.58124 1.07893 1.32585 0.973145 1.05954 0.973145C0.793242 0.973145 0.537847 1.07893 0.349543 1.26724C0.16124 1.45554 0.0554518 1.71093 0.0554518 1.97724C0.0554518 2.24354 0.16124 2.49893 0.349543 2.68724L8.64954 10.9772L0.349543 19.2672C0.244862 19.3569 0.159841 19.4672 0.0998181 19.5913C0.0397948 19.7153 0.00606468 19.8505 0.000745191 19.9882C-0.0045743 20.1259 0.0186312 20.2632 0.0689057 20.3916C0.11918 20.5199 0.195439 20.6364 0.292893 20.7339C0.390348 20.8313 0.506895 20.9076 0.63522 20.9579C0.763545 21.0081 0.900878 21.0314 1.0386 21.026C1.17632 21.0207 1.31145 20.987 1.43551 20.927C1.55958 20.8669 1.6699 20.7819 1.75954 20.6772L10.0595 12.3872L18.3495 20.6772C18.5408 20.8411 18.7869 20.9267 19.0386 20.9169C19.2903 20.9072 19.529 20.8029 19.7071 20.6248C19.8852 20.4467 19.9895 20.208 19.9993 19.9563C20.009 19.7046 19.9234 19.4585 19.7595 19.2672L11.4695 10.9772Z" />
      </svg>
    ) : (
      <>
        <div />
        <div />
        <div />
      </>
    )}
  </div>
);

export default Burger;
